//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "live-block",
    props: {
        live: Object,
        isMobile: false,
    },
    created() {
        if( (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1) ) {
            this.isMobile = true;
        }
    },

    methods: {
        goToLive() {
            window.location = this.live.url;
        }
    }
}
